import { t } from 'i18next';
import { ArrowRightSmall } from '@peacecover/icon';
import { openNewTab } from '@pocapan/shared/utils/UIUtils';
import type { MembersWithLeastPhotoCardsResponse } from '@pocapan/shared/domains/members/services/memberService';

type Props = {
  member: MembersWithLeastPhotoCardsResponse[number];
};

const MemberWithLeastPhotoCardsItem = ({ member }: Props) => (
  <button
    key={member.memberId}
    type="button"
    className="py-[12px] pl-[12px] pr-[8px] flex items-center gap-[16px] rounded-[12px] dark:bg-separator2 shadow-[0_0_2px_0_rgba(0,0,0,0.03),0_0_8px_0_rgba(0,0,0,0.06)]"
    onClick={() =>
      openNewTab(
        `/report-photo-card/event-activities?artistId=${member.artists[0].artistId}&memberId=${member.memberId}`
      )
    }
  >
    <div className="flex flex-col items-start gap-[8px]">
      <p className="text-[15px] font-semibold leading-[18px] text-text-main-lv2 flex items-center">
        {member.name}
        <span className="text-[12px] font-medium leading-[14px] text-text-main-lv4 ml-[4px]">
          · {member.artists[0].artistId}
        </span>
      </p>
      <p className="text-[13px] font-medium leading-[16px] text-text-main-lv4">
        {t('MemberWithLeastPhotoCardsItem.photoCardsCount', { count: member.photoCardsCount })}
      </p>
    </div>
    <ArrowRightSmall size={16} className="text-text-main-lv4" />
  </button>
);

export default MemberWithLeastPhotoCardsItem;
